var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWoman = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385,276.1c-0.3-0.9-33.1-90.7-47.6-132.7c-9.3-27.1-25-40.9-46.5-40.9c-29.9,0-39.9,0-69.8,0 c-21.5,0-37.1,13.8-46.5,40.9c-14.5,42.1-47.3,131.8-47.6,132.7c-3.8,10.4,1.5,22,12,25.8c10.4,3.8,22-1.6,25.8-12 c0.3-0.7,22.8-62.3,38.8-107.6c1.4,4.7,4.4,8.8,8.2,11.6l0,29.5l-34.6,87.2c-1.9,4.8,0.9,10.1,5.8,11.3c5.2,1.2,12,2.9,19.4,4.8 v161.3c0,13.3,10.8,24.1,24.1,24.1s24.1-10.8,24.1-24.1V338c3.5,0.3,6.9,0.3,10.4,0v149.9c0,13.3,10.8,24.1,24.1,24.1 c13.3,0,24.1-10.8,24.1-24.1V326.6c7.4-1.9,14.2-3.5,19.4-4.8c4.9-1.2,7.7-6.5,5.8-11.3l-34.6-87.2l0-29.5 c3.9-2.9,6.8-6.9,8.2-11.6c16,45.3,38.6,106.9,38.8,107.6c3.8,10.4,15.4,15.8,25.8,12C383.4,298.1,388.8,286.5,385,276.1z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 43.9,
    r: 43.9
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWoman, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/woman.ddce261e.svg";
export { ForwardRef as ReactComponent };